/* eslint-disable react-hooks/exhaustive-deps */
import { To } from "react-router-dom";

import {
  usePlacedOrdersAndReturnsCounter,
  useVerificationsCounter,
  useRefundsCounter,
  useEarningsCounter,
  useDamagedItemsCounter,
  useSupportConversationsCounter,
  useAiTicketsCounter,
  useAiReviewCounter
} from "./atoms";

export const useSideBarCounters = () => {
  const { placedOrdersCount, requestedOrderReturnsCount } =
    usePlacedOrdersAndReturnsCounter();
  const { unverifiedResellersCount } = useVerificationsCounter();
  const { earningsCount } = useEarningsCounter();
  const { refundsCount } = useRefundsCounter();
  const { damagedItemsCount } = useDamagedItemsCounter();
  const { supportConversationsCount } = useSupportConversationsCounter();
  const { aiTicketsCount } = useAiTicketsCounter();
  const { aiReviewCount } = useAiReviewCounter();

  const getCounterValueByRoutePath = (routePath?: To) => {
    if (routePath === "/orders") {
      return placedOrdersCount;
    }
    if (routePath === "/returns") {
      return requestedOrderReturnsCount;
    }
    if (routePath === "/verification") {
      return unverifiedResellersCount;
    }
    if (routePath === "/earnings") {
      return earningsCount;
    }
    if (routePath === "/refunds") {
      return refundsCount;
    }
    if (routePath === "/inventory/damaged-items") {
      return damagedItemsCount;
    }
    if (routePath === "/ai/support") {
      return supportConversationsCount;
    }
    if (routePath === "/ai/tickets") {
      return aiTicketsCount;
    }
    if (routePath === "/ai/review") {
      return aiReviewCount;
    }

    return 0;
  };

  return { getCounterValueByRoutePath };
};
